import { useState, useEffect } from 'react'
import './CarouselProduct.scss'
import { BadgeGooglePlay, BadgeAppStore } from '../../../assets/images'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from 'swiper'
import 'swiper/swiper.scss'
import { BannerAPI } from '@api'

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const CarouselProduct = () => {
  const [controller, setController] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [currentIndex, setCurrentIndex] = useState(0)

  const onNext = () => {
    controller.slideNext()
  }

  const onPrevious = () => {
    controller.slidePrev()
  }

  const onErrorException = (e) => {
    e.target.src =
      'https://dummyimage.com/286x175/e8e8e8/9e9e9e&text=Image+Error'
  }

  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  }

  const [carouselProduct, setCarouselProduct] = useState(null)
  useEffect(() => {
    const loadCarousel = async () => {
      const { data } = await BannerAPI({ loc: 'home_product_digital' })
      setCarouselProduct(data.data)
    }
    if (carouselProduct === null) {
      loadCarousel()
    }
  }, [carouselProduct])

  return (
    <div className="carousel-product">
      <div className="carousel-product-content">
        <div className="carousel-product-navigation">
          <button onClick={() => onPrevious()}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button onClick={() => onNext()}>
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
        <Swiper
          slidesPerView={1}
          spaceBetween={5}
          centeredSlides={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          scrollbar={{
            draggable: true,
          }}
          onSwiper={(swiper) => setController(swiper)}
          onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
        >
          {carouselProduct?.map((data, i) => (
            <SwiperSlide key={`carousel-product-${i}`}>
              <div className="carousel-product-content-box">
                <div className="carousel-product-content-box-left">
                  <div className="product-banner">
                    <img
                      src={data.image}
                      onError={onErrorException}
                      alt={data.title}
                    />
                  </div>
                </div>
                <div className="carousel-product-content-box-right">
                  <h2 className="title">{data.title}</h2>
                  <h4 className="product-title">{data.description}</h4>
                  <p className="product-desc">{data.description_2}</p>
                  <div className="get-product">
                    <div className="get-product-left">
                      <img
                        src={BadgeGooglePlay}
                        alt="KBStar PlayStore"
                        onClick={() => {
                          if (getMobileOperatingSystem() === 'Android') {
                            window.open('https://kbbukopin.page.link/vwrq')
                          } else {
                            window.open(
                              'https://play.google.com/store/apps/details?id=com.kbBukopin.Kbstar'
                            )
                          }
                        }}
                      />
                    </div>
                    <div className="get-product-right">
                      <img
                        src={BadgeAppStore}
                        alt="KBStar AppStore"
                        onClick={() => {
                          if (getMobileOperatingSystem() === 'iOS') {
                            window.open('https://kbbukopin.page.link/vwrq')
                          } else {
                            window.open(
                              'https://apps.apple.com/id/app/kbstar/id1620023436'
                            )
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default CarouselProduct
